module.exports = __webpack_public_path__ + "assets/img/tgsm3.027d6547.png";